import { RealtimeDataService } from 'app/_services/realtimeData/realtime-data.service';
import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogConfig } from '@angular/material';
import { Point } from 'app/_class/point';
import { LoginService } from 'app/_services/login.service';
import { Subject, Subscription } from 'rxjs';
import { Vehiculo2 } from 'app/_class/vehiculo2';
import { VehiculoLocalizacion } from 'app/_interfaces/vehiculo-localizacion';
import { SocketService } from 'app/_services/vehicles/socketService .service';

// IMPORTS PARA EL TIMER
import { interval } from 'rxjs/observable/interval';
import 'rxjs/add/operator/takeWhile';
import 'rxjs/add/observable/timer';

export class InputDetalleMapa {
  data: any;           // VehiculoLocalizacion | Vehiculo | Vehiculo2 según el origen
  vehicle?: any;       // usado cuando se abre desde mapa.component con data=null
  needIO: boolean;
  $registroHc = new Subject<VehiculoLocalizacion>();
  isDireccion: boolean;
  clientesConfigurados: number[];
  idCliente: number;
}

@Component({
  selector: 'app-detalle-mapa',
  templateUrl: './detalle-mapa.component.html',
  styleUrls: ['./detalle-mapa.component.css']
})
export class DetalleMapaComponent implements OnDestroy, OnInit {

  readonly noDisponible = 'Sin información';
  item: VehiculoLocalizacion;
  punto: Point = new Point(-33.4517408, -70.6665063);
  config: MatDialogConfig;
  alimentacion: string;
  ignicion: string;
  horometro: string;
  odometro: string;
  conductor: string;
  fechaGPS: Date;
  fechaRegistro: Date;
  temperaturas: number[] = [];
  isLoading = true;
  isDireccion = true;
  suscription: Subscription;
  private readonly refreshingTime = 30000;
  private alive = true;
  vehicles = [];
  focus = {lat: -33.428480, lng: -70.609770,  id: 1};
  first = true;
  points = null;
  prev = null;
  ioData = null;
  bateriaGPS = null;
  activeTab: 'info' | 'complementos' = 'info';
  hasComplementos = false;
  complementoRows: Array<Array<{label: string, value: string}>> = [];
  modeloJimi = "ll301";
  private latestRealtimeMillis: number = null;

  constructor(
    private router: Router,
    private dialogRef: MatDialogRef<DetalleMapaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InputDetalleMapa,
    private loginService: LoginService,
    private realtimeService: RealtimeDataService,
    private socketService: SocketService
    ) {
  }

  ngOnInit(): void {
    this.getIsDireccion()
    if(this.data.needIO || this.isClientConfigurate()){     
      //  ESTO REQUIERE UN ! ANTES DE "this" PARA PROBAR EN LOCALHOST YA QUE NO SE LLEGA A FLOTA COMPLETA Y SE PRUEBA DESDE EL DASHBOARD
      this.getDataFromLatest();
    }else{
      this.getData();
    }

    this.loadInterval();
    this.subscribeSocketPositionUpdates();
  }

  loadInterval() {
    interval(this.refreshingTime)
      .takeWhile(() => this.alive)
      .subscribe(() => {
        if(this.data.needIO || this.isClientConfigurate()){   
          //  ESTO REQUIERE UN ! ANTES DE "this" PARA PROBAR EN LOCALHOST YA QUE NO SE LLEGA A FLOTA COMPLETA Y SE PRUEBA DESDE EL DASHBOARD
          this.getDataFromLatest();
        }else{
          this.getData();
        }
      });
  }

  ngOnDestroy() {
    this.alive = false;
    if (this.suscription) {
      this.suscription.unsubscribe();
    }
  }


  close(): void {
    this.dialogRef.close();
  }

  verHistorial() {
    this.close();
    this.router.navigate(['/dashboard/historialRuta'], { skipLocationChange: true, queryParams: { imei: this.item.imei } });
  }

  cargarDireccion(): void {
    const lat = isNaN(Number(this.item.lat)) ? undefined : Number(this.item.lat);
    const lon = isNaN(Number(this.item.lon)) ? undefined : Number(this.item.lon);
    if (lat === undefined || lon === undefined || lat === 0 || lon === 0) {
      return;
    }

    const point = new Point(lat, lon);

    this.loginService.getDireccion(point).subscribe(response => {
      let {road, house_number, city, county, state, postcode, country} = response.detail;
      road = this.validateNotUndefined(road);
      house_number = this.validateNotUndefined(house_number);
      city = this.validateNotUndefined(city);
      county = this.validateNotUndefined(county);
      state = this.validateNotUndefined(state);
      postcode = this.validateNotUndefined(postcode);
      country = this.validateNotUndefined(country);

      if(house_number == null || house_number.length === 0 || house_number === '') {
        console.log(`${this.item.lat} ${this.item.lon} sin dirección numérica.`)
      }

      const direccion = (point.lat > 0)
                          ? `${road} ${house_number} ${city} ${county} ${state} ${postcode} ${country}`
                          : response.address
                          ;
      this.item.direccion = direccion.replace(",","").trim();
    });
  }

  validateNotUndefined(str: string) {
    return str !== undefined ? str : '';
  }

  getImei(data: any): string | number {
    if (data.data !== null && data.data !== undefined) {
      return data.data.imei;
    }
    // data.vehicle puede ser un Vehiculo2 completo (desde mapa) o solo el imei (legacy)
    const veh = data.vehicle;
    return veh && veh.imei !== undefined ? veh.imei : veh;
  }

  getIsDireccion(){
    this.isDireccion = this.data.isDireccion;
  }

  getData() {
    const imei = this.getImei(this.data);
    // vehicleId disponible si viene de index-dashboard (Vehiculo2.id) o de mapa.component (Vehiculo.id)
    const d = this.data.data;
    const v = this.data.vehicle;
    const vehicleId: number = (d && d.id != null) ? d.id : (d && d.vehicleId != null) ? d.vehicleId : (v && v.id != null) ? v.id : null;
    this.realtimeService.getLocalizacionByImei(imei, vehicleId)
      .subscribe(
        data => { this.parseData(data); },
        error => { console.error('Error getData():', error); }
      );
  }

  // Unificado: el nuevo endpoint siempre trae ioData, no se necesita un segundo llamado
  getDataFromLatest() {
    this.getData();
  }

  private subscribeSocketPositionUpdates(): void {
    const trackedVehicleId = this.getVehicleId(this.data);
    const trackedImei = this.getImei(this.data);

    if (trackedVehicleId === null && (trackedImei === null || trackedImei === undefined || trackedImei === '')) {
      return;
    }

    this.suscription = this.socketService.messages.subscribe((message: string) => {
      const gpsData = this.extractSocketDataForVehicle(message, trackedVehicleId, trackedImei);
      if (!gpsData) {
        return;
      }
      this.applySocketPosition(gpsData, trackedVehicleId);
    });
  }

  private extractSocketDataForVehicle(
    message: string,
    trackedVehicleId: number | null,
    trackedImei: string | number
  ): any | null {
    try {
      const messageData = JSON.parse(message);
      const entries = messageData && Array.isArray(messageData.data) ? messageData.data : [];
      const gpsDataArray = entries
        .map((item: any) => (item && item.gpsData ? item.gpsData : item))
        .filter((item: any) => item !== null && item !== undefined);

      return gpsDataArray.find((gps: any) => {
        const messageVehicleId = gps.vehicleId !== undefined && gps.vehicleId !== null
          ? Number(gps.vehicleId)
          : gps.vehicleid !== undefined && gps.vehicleid !== null
            ? Number(gps.vehicleid)
            : null;
        const messageImei = gps.imei !== undefined && gps.imei !== null ? String(gps.imei) : null;

        if (trackedVehicleId !== null && messageVehicleId !== null) {
          return messageVehicleId === trackedVehicleId;
        }
        return trackedImei !== null && trackedImei !== undefined && messageImei === String(trackedImei);
      }) || null;
    } catch (error) {
      return null;
    }
  }

  private applySocketPosition(gpsData: any, fallbackVehicleId: number | null): void {
    const currentMillis = this.getMillis(gpsData);
    if (currentMillis !== null) {
      if (this.latestRealtimeMillis !== null && currentMillis <= this.latestRealtimeMillis) {
        return;
      }
      this.latestRealtimeMillis = currentMillis;
    }

    const latRaw = gpsData.hasOwnProperty('lat') ? gpsData.lat : gpsData.latitud;
    const lngRaw = gpsData.hasOwnProperty('lon') ? gpsData.lon : gpsData.longitud;
    const lat = Number(latRaw);
    const lng = Number(lngRaw);

    if (Number.isNaN(lat) || Number.isNaN(lng)) {
      return;
    }

    if (this.prev && Number(this.prev.lat) === lat && Number(this.prev.lng) === lng) {
      return;
    }

    const vehicle = new Vehiculo2();
    vehicle.setData(gpsData);
    if ((vehicle.id === null || vehicle.id === undefined) && fallbackVehicleId !== null) {
      vehicle.id = fallbackVehicleId;
    }

    if (vehicle.point) {
      vehicle.point.lat = lat;
      vehicle.point.lng = lng;
    }

    this.vehicles = [vehicle];
    this.punto = new Point(lat, lng);
    const pto = {lat, lng, id: vehicle.id};
    this.focus = pto;
    this.points = this.points ? [...this.points, pto] : [pto];
    this.prev = {lat, lng};

    if (this.item) {
      this.item.lat = lat;
      this.item.lon = lng;
      const socketIgn = gpsData.ign !== undefined && gpsData.ign !== null ? Number(gpsData.ign)
        : gpsData.ignicion !== undefined && gpsData.ignicion !== null ? Number(gpsData.ignicion)
          : null;
      if (socketIgn !== null && !Number.isNaN(socketIgn)) {
        this.item.ign = socketIgn;
        this.ignicion = this.parseIgnicion(socketIgn);
      }

      const socketSog = gpsData.sog !== undefined && gpsData.sog !== null ? Number(gpsData.sog)
        : gpsData.speed !== undefined && gpsData.speed !== null ? Number(gpsData.speed)
          : null;
      if (socketSog !== null && !Number.isNaN(socketSog)) {
        this.item.sog = socketSog;
      }

      const socketCog = gpsData.cog !== undefined && gpsData.cog !== null ? Number(gpsData.cog) : null;
      if (socketCog !== null && !Number.isNaN(socketCog)) {
        this.item.cog = socketCog;
      }
    }
  }

  parseData(data: VehiculoLocalizacion) {
    if (!data) {
      console.error('Los datos recibidos no son válidos:', data);
      return;
    }

    const extra = this.data.needIO ? (data.ioData !== undefined ? data.ioData : null) : null;
    const equipoModelo = data.modelo !== undefined ? data.modelo : null;
    const idCliente = data.cliente !== undefined ? data.cliente : null;
    const batteryPercent = data.batteryPercent !== undefined ? data.batteryPercent : null;

    const vehicle = new Vehiculo2();
    vehicle.setData(data);
    const currentMillis = this.getMillis(data);
    const isStaleByMillis = currentMillis !== null
      && this.latestRealtimeMillis !== null
      && currentMillis < this.latestRealtimeMillis;

    if (isStaleByMillis) {
      // Evita que una respuesta HTTP más antigua pise una posición ya actualizada por socket
      return;
    }

    if (currentMillis !== null && (this.latestRealtimeMillis === null || currentMillis > this.latestRealtimeMillis)) {
      this.latestRealtimeMillis = currentMillis;
    }

    const positionChanged = !this.prev
      || this.prev.lat !== vehicle.point.lat
      || this.prev.lng !== vehicle.point.lng;

    if (positionChanged) {
      this.applyVehicleData(data, vehicle, extra, idCliente, equipoModelo, batteryPercent);
    }

    this.prev = { lat: vehicle.point.lat, lng: vehicle.point.lng };
  }

  private applyVehicleData(
    data: VehiculoLocalizacion,
    vehicle: Vehiculo2,
    ioExtra: any,
    idCliente: number,
    equipoModelo: string,
    batteryPercent: number
  ) {
    const prevDireccion = this.item && this.item.direccion ? this.item.direccion : '';
    const newPoint = new Point(vehicle.point.lat, vehicle.point.lng);

    this.vehicles = [vehicle];
    this.punto = newPoint;
    this.item = data;
    this.alimentacion = data.power !== undefined && data.power !== null ? data.power : this.noDisponible;
    this.ignicion = this.parseIgnicion(data.ign);
    this.horometro = this.parseSeconds(data.horometro);
    this.odometro = Math.round(((data.odometro !== undefined && data.odometro !== null ? data.odometro : 0)) / 1000).toString();
    this.fechaGPS = data.epoch ? new Date(data.epoch) : null;
    this.fechaRegistro = data.reg_at > 0 ? new Date(data.reg_at) : null;
    this.isLoading = false;
    this.conductor = data.conductor;
    this.ioData = ioExtra !== null && ioExtra.length > 4 ? ioExtra.slice(0, 4) : ioExtra;
    this.bateriaGPS = this.getPercentBattery(equipoModelo, batteryPercent);

    if (this.first || !this.punto.equals(newPoint)) {
      this.first = false;
      // La dirección llega resuelta desde el endpoint con ?direccion=true
      // this.cargarDireccion(); // comentado: reemplazado por data.direccion del endpoint
      this.item.direccion = data.direccion || 'N/D';
    } else {
      this.item.direccion = prevDireccion;
    }

    const pto = { lat: Number(vehicle.point.lat), lng: Number(vehicle.point.lng), id: vehicle.id };
    this.focus = pto;
    this.points = this.points ? [...this.points, pto] : [pto];
    this.buildComplementoRows();
  }

  private parseIgnicion(ign: number): string {
    if (ign === 1) { return 'Encendido'; }
    if (ign === 0) { return 'Apagado'; }
    return this.noDisponible;
  }

  parseSeconds(timeSeconds: number) {
    const relojhh = Math.floor(timeSeconds / 3600);
    const relojmm = Math.floor((timeSeconds - relojhh * 3600) / 60);
    const relojss = timeSeconds - (relojmm * 60 + relojhh * 3600);
    return `${this.pad(relojhh, 7)}:${this.pad(relojmm, 2)}:${this.pad(relojss, 2)}`;
  }

  pad(num: number, size: number) {
    const s = '000000000000000' + num;
    return s.substring(s.length - size);
  }
  /**
   * Obtiene el porcentaje de bateria de un equipo Jimi Iot 
   * para el cliente chilexpress seguridad "2603", waypoint i+d "1040"(para pruebas), operaciones 582 (para pruebas)
   */
  getPercentBattery(equipoModelo: string, batteryPercent: number) {
    if (!equipoModelo || batteryPercent === undefined || batteryPercent === null) {
      return null;
    }

    return equipoModelo.toLowerCase().includes(this.modeloJimi)
      ? batteryPercent + '%'
      : null;
  }
/**
 * Verifica si el cliente seleccionado esta configurado en el
 * configFlotaCompleta.txt
 * @returns true si esta en la lista, false si no esta
 */
  isClientConfigurate(): boolean {
    if(this.data.clientesConfigurados && this.data.idCliente){
      return this.data.clientesConfigurados.includes(this.data.idCliente);
    }
    return false;
  }

  private getVehicleId(data: InputDetalleMapa): number | null {
    const d: any = data ? data.data : null;
    const v: any = data ? data.vehicle : null;

    const rawId = (d && d.id != null) ? d.id
      : (d && d.vehicleId != null) ? d.vehicleId
      : (d && d.vehicleid != null) ? d.vehicleid
      : (v && v.id != null) ? v.id
      : (v && v.vehicleId != null) ? v.vehicleId
      : (v && v.vehicleid != null) ? v.vehicleid
      : null;

    if (rawId === null || rawId === undefined) {
      return null;
    }

    const id = Number(rawId);
    return Number.isNaN(id) ? null : id;
  }

  getInputValue(ioNumero: number): number | null {
    if (!this.item) { return null; }
    const val = (this.item as any)['input' + ioNumero];
    return (val !== undefined && val !== null) ? Number(val) : null;
  }

  getIoState(ioEntry: any): string {
    const val = this.getInputValue(ioEntry.ioNumero);
    if (val === 1) { return ioEntry.estadoActivo; }
    if (val === 0) { return ioEntry.estadoInactivo; }
    return this.noDisponible;
  }

  getAdcValue(adcEntry: any): string {
    if (!this.item) { return this.noDisponible; }
    const key = adcEntry.adc === 1 ? 'adc' : 'adc' + adcEntry.adc;
    const val = (this.item as any)[key];
    return (val !== undefined && val !== null && val > -40) ? val + 'ºC' : this.noDisponible;
  }

  getSensorValue(sensor: any): string {
    if (!this.item) { return this.noDisponible; }
    const key = sensor.adc === 1 ? 'adc' : 'adc' + sensor.adc;
    const val = (this.item as any)[key];
    return (val !== undefined && val !== null && val > -40) ? String(val) : this.noDisponible;
  }

  private buildComplementoRows(): void {
    const items: Array<{label: string, value: string}> = [];

    if (this.item.adcData) {
      for (const entry of this.item.adcData) {
        items.push({ label: entry.nomAdcnom, value: this.getAdcValue(entry) });
      }
    }
    if (this.item.ioData) {
      for (const entry of this.item.ioData) {
        if (this.getInputValue(entry.ioNumero) !== null) {
          const label = entry.ioSubclase ? `${entry.ioNombre} - ${entry.ioSubclase}` : entry.ioNombre;
          items.push({ label, value: this.getIoState(entry) });
        }
      }
    }
    if (this.item.sensorData) {
      for (const sensor of this.item.sensorData) {
        items.push({ label: sensor.nombreSensor, value: this.getSensorValue(sensor) });
      }
    }

    this.hasComplementos = items.length > 0;
    this.complementoRows = [];
    for (let i = 0; i < items.length; i += 3) {
      this.complementoRows.push(items.slice(i, i + 3));
    }
  }

  private getMillis(data: any): number | null {
    if (!data) {
      return null;
    }
    const rawMillis = data.epoch !== undefined && data.epoch !== null
      ? data.epoch
      : data.utc !== undefined && data.utc !== null
        ? data.utc
        : data.fechaEmision !== undefined && data.fechaEmision !== null
          ? data.fechaEmision
          : null;

    if (rawMillis === null) {
      return null;
    }

    const millis = Number(rawMillis);
    return Number.isNaN(millis) ? null : millis;
  }

}
